import { render, staticRenderFns } from "./pdf-object.vue?vue&type=template&id=7ac01a38&scoped=true&"
import script from "./pdf-object.component.ts?vue&type=script&lang=ts&"
export * from "./pdf-object.component.ts?vue&type=script&lang=ts&"
import style0 from "./pdf-object.vue?vue&type=style&index=0&id=7ac01a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac01a38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/3/gateway/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac01a38')) {
      api.createRecord('7ac01a38', component.options)
    } else {
      api.reload('7ac01a38', component.options)
    }
    module.hot.accept("./pdf-object.vue?vue&type=template&id=7ac01a38&scoped=true&", function () {
      api.rerender('7ac01a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/pdf-object/pdf-object.vue"
export default component.exports